@import '../../shared/chat-bubble/chat-bubble.scss';
og-chat-prompt {
  contain: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .chat-wrapper {
    z-index: 10;
    position: absolute;
    bottom: var(--ion-safe-area-bottom);
    width: 100%;
  }
  .snooze-wrapper {
    display: flex;
    justify-content: flex-end;
    padding: 8px;
    ion-chip {
      --background: var(--ion-color-dark);
      --color: var(--ion-color-light);
      ion-icon {
        color: var(--ion-color-light);
      }
    }
  }
  ion-backdrop {
    opacity: var(--ion-backdrop-opacity, 0.32);
  }
}
